// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37_y4","content":"styles_content__3kF-N","tableWrap":"styles_tableWrap__3mXr6"};